import { Validator } from 'vee-validate';
import { BasicSelect } from 'vue-search-select';
import Matrix from './../../../../../shared/components/matrix';
import MasterService from './../../../../services/masterdata.service';
import CONSTANT from './../../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import XLSX from 'xlsx';
import Papa from "papaparse";
import CustomExpandableTable from './../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../shared/components/pagination';

export default {
	name: 'Basr-Rate',
	components: {
		Matrix,
		BasicSelect,
		VueElementLoading,
		Treeselect,
		CustomExpandableTable,
		Pagination
	},
	props: ['callFrom','ratebasis','servicetype'],
	data: function() {
		return {
			isSaved:false,
			isLoading: false,
			isFullMatrixCreation: false,
			matrixHeaderZoneArray: [],
			matrixHeaderCityArray: [],
			matrixTableDataZoneArray: [],
			matrixTableDataCityArray: [],
			matrixSlabHeaderArray: [],
			matrixTableDataSlabCityArray: [],
			matrixTableDataSlabZoneArray: [],
			tabIndex: '',
			slabId: null,
			SYMBOL_CONFIG: {
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
			},
			tariffCardId: null,
			rateTemplateId: null,
			isMatrixSaveButtonHidden: true,
			selectedEditRowDataEdit: {},
			matrixLabel: {
				horizontal: "Pickup From",
				verticle: "Deliver To"
			},
			tariffCardList: [],
			selectedTarrifCard: {
				label: '',
				id: ''
			},
			tarifftype: '',
			type: null,
			tarrifCardModel:null,
			downloadData:[],
			slabtype:'',
			baserateslabchargetype:'',
			getOldSlabDetailsArray:'',
			baseratepresent:'',
			isMasterRate:'',
			UpdateRateTatType:'',
			TariffCardTemplate:'',
			AnotherTariffCard:null,
			validatedData: [{
				isupload: 0,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				downloadLabel : 'Download Rate Template',
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				isvalidationdone: false,
				isfilechose: false,
				file: null,
				filename: null
			}],
			userid:"",
      		userreferencestring: "",
			routeMode:"",
			ischanged:false,
			ratetemplatelength:0,
			rateTemplateData:[],
			disabledPreviousSelection: false,
			tableColumnSlab:['Sheet Row Number','Origin Region','Origin State','Origin City','Origin Territory',
			'Destination Region','Destination State','Destination City','Destination Territory',
			'Route Mode','Rate basis','Rate Type Flat/Slab','Slab Type','Slab Break','Rate per basis (INR)','Invalid Reason'],
			tableColumnFlat:['Sheet Row Number','Origin Region','Origin State','Origin City','Origin Territory',
			'Destination Region','Destination State','Destination City','Destination Territory',
			'Route Mode','Rate basis','Rate Type Flat/Slab','Rate per basis (INR)','Invalid Reason'],
			initialTariffcardId:null,
			zones : [],
			addcities : false,
			validatedDataZonetoZone: [{
				isupload: 0,
				validdata: 0,
				invaliddata: 0,
				tableItems : [],
				downloadLabel : 'Download Rate Template',
				totalPage : 0,
				currentPage :  1,
				totalCount : 0,
				offset :  0,
				pageLimit : 10,
				totalrecords: 0,
				isvalidationdone: false,
				isfilechose: false,
				file: null,
				filename: null,
			}],
			arrOfMatrix : [],
			tableColumnsZoneFlat : ['Origin Zone','Destination Zone','Rate','Invalid Reason'],
			additionalCitiesDownloadTemplate : [],
			additionalCitiesDownloadTemplateLength : null,
			ZoneFileUpload:[],
			ExceptionalCitiesUpload: [],
			isExceptionalcitiespresent: false,
			isbaserateslabchargetypechanged : false
		}
	},
	computed: {
	},
	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
		this.userid = userdetail.userid;
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let text = "";
    for (let i = 0; i < 3; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    let uniquerefno = this.userid+text;
    this.userreferencestring = uniquerefno;

  },
  methods: {
		async	onChangeUpdateRateTatType(){
			try {
				this.ischanged = true;
				if(this.UpdateRateTatType=="TariffCardTemplate"){
					this.disabledPreviousSelection = false;
					this.rateTemplateData = [];
					this.ratetemplatelength = 0;
				}else{
					this.isLoading = true;
					this.disabledPreviousSelection = true;
					this.AnotherTariffCard = null;
					//get sales tat from contact services for download Rate Template creation
					let inputPayload = {
					  clientcontractservicesid: this.callFrom.contractservicesid,
					  servicetype : this.servicetype
					}
					let result = await MasterService.getClientContractServiceSalesTAT(inputPayload);
					this.rateTemplateData = result.data.data;
					this.ratetemplatelength = result.data.data.length;
					this.isLoading = false;
				}
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
    },
		async downloadRateTemplate(lowerlimit, higherlimit){
			try {
				this.isLoading = true;
				let downloadData = [];
				this.rateTemplateData.forEach(item => {
					let obj = {
						'Origin Region': item.originregion,
						'Origin State': item.originstate,
						'Origin City': item.origincity,
						'Origin Territory': item.originterritory,
						'Destination Region': item.destinationregion,
						'Destination State': item.destinationstate,
						'Destination City': item.destinationcity,
						'Destination Territory': item.destinationterritory,
						'Route Mode': item.travelmode,
						'Rate basis': this.selectedEditRowDataEdit.ratebasis == 1 ? 'Weight' : 'Quantity',
						'Rate Type Flat/Slab': this.selectedEditRowDataEdit.tariffcardtype == 1 ? 'Flat' : 'Slab',
					}
					if (this.selectedEditRowDataEdit.tariffcardtype == 2) {
						obj['Slab Type (Weight/ Quantity)'] = this.selectedEditRowDataEdit.slabtype == 1 ? "Weight" : "Quantity";
						obj["Slab Break (Low - High)"] = parseInt(lowerlimit) + ' to ' + parseInt(higherlimit);
					}
					obj['Rate per basis (INR)'] = "";
					downloadData.push(obj);
				});
				this.makeXls(downloadData,'Tariff.csv');
				this.isLoading = false;
				return true;
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
		async makeXls(xlsdata,name){
			var blob = new Blob([Papa.unparse(xlsdata)], { type: 'text/csv;charset=utf-8;' });
			var link = document.createElement("a");
			var url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", name);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			return;
		},
		async chooseFile(e, index, isSlab=0) {
			try {
				console.log("abcity");
				this.ischanged = true;
				this.validatedData[index].isupload = 0;
				this.validatedData[index].validdata = 0;
				this.validatedData[index].invaliddata = 0;
				this.validatedData[index].tableItems = [];
				this.validatedData[index].totalPage = 0;
				this.validatedData[index].currentPage =  1;
				this.validatedData[index].totalCount = 0;
				this.validatedData[index].offset =  0;
				this.validatedData[index].pageLimit = 10;
				const files = e.target.files;
				if (!files.length) {
					this.$refs.files.value = null;
					return;
				} else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
					this.$refs.files.value = null;
					return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
				}else{
					this.validatedData[index].file = e.target.files[0];
					this.validatedData[index].filename = e.target.files[0].name;
					this.validatedData[index].isfilechose = true;
					this.validatedData[index].isvalidationdone = false;
				  this.validatedData[index].isDisable = false;
					if(isSlab){
						this.$refs.files[index].value = null;
					}else{
						this.$refs.files.value = null;
					}
					await this.parseFile(index, isSlab);
				}
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		async parseFile(index, isSlab){
      let userid = this.userid;
      let userreferencestring = this.userreferencestring;
      var count = 0; // cache the running count
      var csvData=[];
      var sheetid = 1;
      var validheader = 1;
      Papa.parse( this.validatedData[index].file, {
          header: true,
          skipEmptyLines: true,
          before: this.isLoading = true,
          worker: true, // Don't bog down the main thread if its a big file
          step: function(result) {
            let fileHeaders = result.meta.fields;
						if(isSlab && fileHeaders.length!=14){
							validheader = 0;
						}else if(!isSlab && fileHeaders.length!=12){
							validheader = 0;
						}else if(isSlab && sheetid==1 && (!fileHeaders.includes("Origin Region") ||
							!fileHeaders.includes("Origin State") ||
							!fileHeaders.includes("Origin City") ||
							!fileHeaders.includes("Origin Territory") ||
							!fileHeaders.includes("Destination Region") ||
							!fileHeaders.includes("Destination State") ||
							!fileHeaders.includes("Destination City") ||
							!fileHeaders.includes("Destination Territory") ||
							!fileHeaders.includes("Route Mode") ||
							!fileHeaders.includes("Rate basis") ||
							!fileHeaders.includes("Rate Type Flat/Slab") ||
							!fileHeaders.includes("Slab Type (Weight/ Quantity)") ||
							!fileHeaders.includes("Slab Break (Low - High)") ||
							!fileHeaders.includes("Rate per basis (INR)"))){
							validheader = 0;
						}else if(sheetid==1 && !fileHeaders.includes("Origin Region") ||
	              !fileHeaders.includes("Origin State") ||
	              !fileHeaders.includes("Origin City") ||
	              !fileHeaders.includes("Origin Territory") ||
	              !fileHeaders.includes("Destination Region") ||
	              !fileHeaders.includes("Destination State") ||
	              !fileHeaders.includes("Destination City") ||
	              !fileHeaders.includes("Destination Territory") ||
	              !fileHeaders.includes("Route Mode") ||
	              !fileHeaders.includes("Rate basis") ||
	              !fileHeaders.includes("Rate Type Flat/Slab") ||
	              !fileHeaders.includes("Rate per basis (INR)")){
								validheader = 0;
							}
							sheetid ++;
	            let tempResult = {};
              tempResult.originregion = (result.data['Origin Region'])?result.data['Origin Region']:null;
              tempResult.originstate = (result.data['Origin State'])?result.data['Origin State']:null;
              tempResult.origincity = (result.data['Origin City'])?result.data['Origin City']:null;
              tempResult.originterritory = (result.data['Origin Territory'])?result.data['Origin Territory']:null;
              tempResult.destinationregion = (result.data['Destination Region'])?result.data['Destination Region']:null;
              tempResult.destinationstate = (result.data['Destination State'])?result.data['Destination State']:null;
              tempResult.destinationcity = (result.data['Destination City'])?result.data['Destination City']:null;
              tempResult.destinationterritory = (result.data['Destination Territory'])?result.data['Destination Territory']:null;
              tempResult.travelmode = (result.data['Route Mode'])?result.data['Route Mode']:null;
              tempResult.ratebasis = (result.data['Rate basis'])?result.data['Rate basis']:null;
              tempResult.ratetype = (result.data['Rate Type Flat/Slab'])?result.data['Rate Type Flat/Slab']:null;
							if(isSlab){
								tempResult.slabtype = (result.data['Slab Type (Weight/ Quantity)'])?result.data['Slab Type (Weight/ Quantity)']:null;
								tempResult.slabbreak = (result.data['Slab Break (Low - High)'])?result.data['Slab Break (Low - High)']:null;
								tempResult.slabsequence = index+1;
							}
              tempResult.rateperbasis = (result.data['Rate per basis (INR)'])?result.data['Rate per basis (INR)']:null;
              tempResult.status = 0;
              tempResult.userid = userid;
              tempResult.userreferencestring = userreferencestring;
              tempResult.sheetid = sheetid;
			  tempResult.servicetype = 1;
	            csvData.push(tempResult);
          },
          complete: function(){
            if(validheader==0){
							this.isLoading = false;
							this.resetFiles(index);
              return this.$alert('File headers are not matched. Please download Tariff card csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
            }else if(csvData.length<1){
							this.isLoading = false;
							this.resetFiles(index);
              return this.$alert('Tariff file data should not be blank. At least one record set is required.', "", "error");
            }else if(this.servicetype == 1 && this.ratetemplatelength != csvData.length){
					this.isLoading = false;
					this.resetFiles(index);
	  				return this.$alert('Selected file total records were not matched with Download Rate Template total records.', "", "error");
			}else if(this.servicetype == 2 && this.additionalCitiesDownloadTemplateLength != csvData.length){
					this.resetFiles(index);
					this.isLoading = false;
					return this.$alert('Selected file total records were not matched with Download Rate Template total records.', "", "error");
				}	
			else{
				this.validatedData[index].totalrecords = csvData.length;
              this.chunkArray(csvData, 20000, index, isSlab ,this.servicetype == 2 ? 1 :0);
            }
          }.bind(this)
      } );
    },
		async chunkArray(myArray, chunk_size, slabindex, isSlab , isExceptionalcities){
      try {

		   await this.deletePreviousUploadRatesTAT(slabindex, isSlab, isExceptionalcities);	
		
        var index = 0;
        var arrayLength = myArray.length;
        let tempArr = [];
        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index+chunk_size);
            await this.uploadRateFile(myChunk, isSlab);
        }
        this.$alertify.success("File data loaded Successfully");
        this.isLoading = false;
      }catch (err){
        console.log(err);
      }
    },
    async deletePreviousUploadRatesTAT(slabindex, isSlab,isExceptionalcities){
      try{
        this.isLoading = true;
        var inputPayload = {};
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        inputPayload.slabindex = (isSlab)?slabindex+1:null;
		inputPayload.servicetype = this.servicetype;
		if (isExceptionalcities) {
		inputPayload.isExceptionalcities = isExceptionalcities	
		}
        let result = await MasterService.deletePreviousUploadRateTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
		async uploadRateFile(filechunkdata){
      try{
        var inputPayload = {};
        inputPayload.file = filechunkdata;
        let result = await MasterService.uploadRateTAT(inputPayload);
      } catch(err){
        console.log(err);
      }
    },
		async validateTariff(val, index) {
			try {
				this.isLoading = true;
				var inputPayload = {};
        inputPayload.routemode =  this.servicetype == 1 ?  this.rateTemplateData[0].travelmode : this.additionalCitiesDownloadTemplate[0].travelmode;
        inputPayload.rateType = this.tarifftype;
        inputPayload.contractservicesid = this.callFrom.contractservicesid;
        inputPayload.ratebasis = this.ratebasis;
				if(this.tarifftype == 'slab'){
					inputPayload.slabType = this.selectedEditRowDataEdit.slabtype;
					inputPayload.slabnumber = this.getOldSlabDetailsArray[index].slabnumber;
					let breaktitle = this.getOldSlabDetailsArray[index];
					inputPayload.slabbreak = parseInt(breaktitle.lowerlimitvalue)+' to '+parseInt(breaktitle.higherlimitvalue);
				}
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
        let result = await MasterService.validateClientContractTariff(inputPayload);
        this.isLoading = false;
				if (result.data.code == 200) {
					let resultData = result.data.data;
					this.validatedData[index].isupload = 1;
					let successCount = 0;
          let failedCount = 0;
          resultData.forEach((element) => {
              if(element.status==1){
                successCount = element.count;
              }
              if(element.status==2){
                failedCount = element.count;
              }
          });
					this.validatedData[index].isvalidationdone = true;
					this.validatedData[index].validdata = parseInt(successCount);
					this.validatedData[index].invaliddata = parseInt(failedCount);
					this.validatedData[index].currentPage = 1;
					this.validatedData[index].pageLimit = 10;
					this.validatedData[index].offset = 0;
					this.validatedData[index].totalCount = parseInt(failedCount);
					this.validatedData[index].totalPage = Math.ceil(parseInt(failedCount) / this.validatedData[index].pageLimit);
					this.setInvalidData(index);
				} else {
					this.validatedData[index].isupload = 0;
					this.validatedData[index].validdata = 0;
					this.validatedData[index].invaliddata = 0;
					this.$alert(result.data.message, this.seriveLevelTemplateName, "error");
				}
				this.validatedData[index].isDisable = true;
			} catch (error) {
				this.isLoading = false;
				console.log(error);
			}
		},
		onPageChange(page,index) {
			this.validatedData[index].currentPage = page;
			this.validatedData[index].offset = (page - 1) * this.validatedData[index].pageLimit;
			this.setInvalidData(index);
		},
		async setInvalidData(index){
			try {
				console.log("here");
				this.isLoading = true;
				let inputPayload = {
					"offset": this.validatedData[index].offset,
					"limit": this.validatedData[index].pageLimit,
				}
				inputPayload.userid = this.userid;
				inputPayload.userreferencestring = this.userreferencestring;
				if(this.tarifftype=='slab'){
					inputPayload.slabsequence = index+1;
				}
				let result = await MasterService.getInvalidRateTATListing(inputPayload);
				this.isLoading = false;
				this.validatedData[index].tableItems = [];
				let data = result.data.data.rows;
				data.forEach(el => {
					let obj = {
						id: el.id,
						'Sheet Row Number': el.sheetid,
						'Origin Region':el.originregion,
						'Origin State': el.originstate,
						'Origin City':el.origincity,
						'Origin Territory':el.originterritory,
						'Destination Region':el.destinationregion,
						'Destination State':el.destinationstate,
						'Destination City':el.destinationcity,
						'Destination Territory':el.destinationterritory,
						'Route Mode':el.travelmode,
						'Rate basis': el.ratebasis,
						'Rate Type Flat/Slab': el.ratetype,
						'Rate per basis (INR)': el.rateperbasis,
						'Invalid Reason':el.comment,
					}
					if (this.tarifftype == 'slab') {
						obj['Slab Type'] = el.slabtype,
						obj['Slab Break'] = el.slabbreak.toString();
					}
					this.validatedData[index].tableItems.push(obj);
				})
			} catch(err){
				this.isLoading = false;
				console.log(err);
			}
		},
		resetFiles(index) {
			this.validatedData[index].isvalidation = false;
			this.validatedData[index].isfilechose = false;
			this.validatedData[index].validdata = 0;
			this.validatedData[index].invaliddata = 0;
			this.validatedData[index].tableItems = [];
			this.validatedData[index].totalPage = 0;
			this.validatedData[index].currentPage =  1;
			this.validatedData[index].totalCount = 0;
			this.validatedData[index].offset =  0;
			this.validatedData[index].pageLimit = 10;
			this.validatedData[index].totalrecords = 0;
			this.validatedData[index].isvalidationdone = false;
			this.validatedData[index].file = null;
			this.validatedData[index].filename = null;
			this.validatedData[index].isDisable = true;
		},
		async downloadInvalidData(index) {
			try {
				this.isLoading = true;
        let inputPayload = {}
        inputPayload.userid = this.userid;
        inputPayload.userreferencestring = this.userreferencestring;
				if(this.tarifftype=='slab'){
					inputPayload.slabnumber = index+1;
				}
        let result = await MasterService.getInvalidRateTATForDownload(inputPayload);
				let data = result.data.data.rows;
				let tempData = [];
				data.forEach(el => {
					let obj = {
						id: el.id,
						'Sheet Row Number': el.sheetid,
						'Origin Region':el.originregion,
						'Origin State': el.originstate,
						'Origin City':el.origincity,
						'Origin Territory':el.originterritory,
						'Destination Region':el.destinationregion,
						'Destination State':el.destinationstate,
						'Destination City':el.destinationcity,
						'Destination Territory':el.destinationterritory,
						'Route Mode':el.travelmode,
						'Rate basis': el.ratebasis,
						'Rate Type': el.ratetype,
						'Rate per basis (INR)': el.rateperbasis,
						'Invalid Reason':el.comment,
					}
					if (this.ratetype == 'slab') {
						obj['Slab Type'] = el.slabtype,
						obj['Slab Break'] = el.slabbreak.toString();
					}
					tempData.push(obj);
				})
				this.makeXls(tempData,'Invalid Rate.csv');
				this.isLoading = false;
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
    async setValues(rateTemplateDetailsObject, isMasterRate ,isSaved){
		await this.getTariffCardListing();
		await this.getZonenamesdata()
      if(rateTemplateDetailsObject && rateTemplateDetailsObject.id){
				this.rateTemplateId = rateTemplateDetailsObject.id;
				await this.checkForBaseRateIsAlreadyPresent(isMasterRate,isSaved);
			}
		},
		async checkForBaseRateIsAlreadyPresent(isMasterRate,isSaved) {
			try {
				this.isMasterRate = isMasterRate
				if (this.rateTemplateId) {
					let inputPayload = {
						ratetemplateid: this.rateTemplateId
					}
					let result;
					this.isLoading = true;
					let alreadysaveddata = isSaved && isSaved == 2 ? false : this.isSaved

					if (!alreadysaveddata && (!this.callFrom || isMasterRate)) {
						result = await MasterService.getBasicBaserate(inputPayload);
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id;
						result = await MasterService.getContractBasicBaserate(inputPayload);
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id;
						result = await MasterService.getClientContractBasicBaserate(inputPayload);
						if(result.data.data.length >0 && result.data.data[0].tariffcardid){
							this.initialTariffcardId = result.data.data[0].tariffcardid;
							this.isExceptionalcitiespresent = result.data.data[0].isexceptionalcity ? true : false
						}
					}
					await this.checkIsSlabSelected(result);
					this.isLoading = false;
			}
				
			} catch (err) {
			 console.log(err);
			}
			
		},
		async checkIsSlabSelected(result) {
			if(result.data.data && result.data.data[0] && result.data.data[0].tariffcardid){
				this.baseratepresent = true;
				this.tariffCardId = result.data.data[0].tariffcardid;
				this.baserateslabchargetype = result.data.data[0].baserateslabchargetype;
				this.selectedEditRowDataEdit.tariffcarddetails = result.data.data;
				this.selectedEditRowDataEdit.ratebasis = result.data.data[0].ratebasis;
				this.selectedEditRowDataEdit.slabtype = result.data.data[0].slabtype;
				if (result.data.data && result.data.data[0] && result.data.data[0].slabid) {
					this.selectedEditRowDataEdit.tariffcardtype = CONSTANT.BASE_RATE_TYPE.SLAB;
				}else{
					this.selectedEditRowDataEdit.tariffcardtype = CONSTANT.BASE_RATE_TYPE.FLAT;
				}
				await this.getTariffCardListing(this.ratebasis);
				console.log("tariffCardList",this.tariffCardList);
				console.log("result.data.data[0].tariffcardid)",result.data.data[0].tariffcardid);
				let obj = this.tariffCardList.find(o => o.id == result.data.data[0].tariffcardid);
				this.selectedTarrifCard.label = obj && obj.label;
				this.selectedTarrifCard.id = obj && obj.id;
				this.tarrifCardModel = obj && obj.id;
				console.log("obj",obj);
				await this.setSelectedTarrifCardDetails();
			}
		},
		linkClass(idx) {
			if (this.tabIndex === idx) {
				return ['bg-primary', 'text-light']
			} else {
				return ['bg-light', 'text-info']
			}
		},
		selectCard(data) {
			if(data.id){
				this.tarrifCardModel = data.id;
				this.selectedTarrifCard.id = data.id;
				this.selectedTarrifCard.label = data.label;
				this.baseratepresent = false;
				this.ischanged = true;
				this.getDetailsTarrifCard(data.id);
			}
		},
		selectNewCard(data) {
			if(data.id){
				this.ischanged = true;
				this.getDetailsTarrifCard(data.id);
			}
		},
		async getDetailsTarrifCard(tariffcardid) {
			try {
				let payload = {
					tariffcardid: tariffcardid
				}
				this.tariffCardId = tariffcardid;
				this.isLoading = true;
				let result = await MasterService.getBasicTariffData(payload);
				this.selectedEditRowDataEdit = result.data.data.tariffmaster;
				this.isLoading = false;
				this.setSelectedTarrifCardDetails(tariffcardid);
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async setSelectedTarrifCardDetails(){
			if(this.selectedEditRowDataEdit){
				if(this.selectedEditRowDataEdit.tariffcardtype==CONSTANT.BASE_RATE_TYPE.FLAT) {
				this.tarifftype = 'flat';
				this.slabtype = '';
				}else if(this.selectedEditRowDataEdit.tariffcardtype==CONSTANT.BASE_RATE_TYPE.SLAB){
				await this.getOldslabDeatils();
				this.tarifftype = 'slab';
				this.slabtype = (this.selectedEditRowDataEdit.slabtype == 1)?"Weight":(this.selectedEditRowDataEdit.slabtype == 2)?"Quantity":"";
				this.getSlabDetailsUpdate(this.getOldSlabDetailsArray);
				}
			}
		},
		async getOldslabDeatils(){
			try {
				this.isLoading = true;
				let result = await MasterService.getUploadedSlabDetails({tariffcardid:this.tariffCardId});
				if(result.data.code == 200){
					this.getOldSlabDetailsArray = result.data.data;
				}
			} catch (error) {
				this.isLoading = false;
				console.log(error)
			}
		},
		groupBy(array, property) {
			var hash = {};
			for (var i = 0; i < array.length; i++) {
				if (!hash[array[i][property]]) hash[array[i][property]] = [];
				hash[array[i][property]].push(array[i]);
			}
			return hash;
		},
		async createCsvForDownload(index ,exceptionalcity) {
			let slabsequence;
			let downloadArray = [];
			if (index || index ==0) {
				slabsequence = index + 1;
			}else{
				slabsequence = 0;
			}
			let servicetype  = this.servicetype
			if (exceptionalcity) {
				servicetype = 1
			}
			await this.getBaseRateDetail(slabsequence ,servicetype);
			if(this.servicetype == 1 || exceptionalcity){
			if (this.tarifftype == 'slab') {
			downloadArray = this.downloadData.map((el)=>{
				 return {
				 		 "Origin Region":el.originregion,
						 "Origin State":el.originstate,
						 "Origin City":el.origincity,
						 "Origin Territory":el.originterritory,
						 "Destination Region":el.destinationregion,
						 "Destination State":el.destinationstate,
						 "Destination City":el.destinationcity,
						 "Destination Territory":el.destinationterritory,
						 "Route Mode":el.travelmode,
						 "Rate basis":(this.ratebasis == 1)?"Weight":(this.ratebasis == 2)?"Quantity":"",
						 "Rate Type Flat/Slab": 'Slab',
						 "Slab Type (Weight/ Quantity)" :(this.selectedEditRowDataEdit.slabtype == 1)?"Weight":(this.selectedEditRowDataEdit.slabtype == 2)?"Quantity":"",
						 "Slab Break (Low - High)":el.lowerlimitvalue+" to "+el.higherlimitvalue,
						 "Rate per basis (INR)":el.tariffrate
				 }
			 });
		 	}else {
			downloadArray = this.downloadData.map((el)=>{
				 return {
				 		 "Origin Region":el.originregion,
						 "Origin State":el.originstate,
						 "Origin City":el.origincity,
						 "Origin Territory":el.originterritory,
						 "Destination Region":el.destinationregion,
						 "Destination State":el.destinationstate,
						 "Destination City":el.destinationcity,
						 "Destination Territory":el.destinationterritory,
						 "Route Mode":el.travelmode,
						 "Rate basis":(this.ratebasis == 1)?"Weight":(this.ratebasis == 2)?"Quantity":"",
						 "Rate Type Flat/Slab" : 'Flat',
						 "Rate per basis (INR)":el.tariffrate
				 }
	 		 });
		 }
        }else{
            downloadArray= await this.createMatrixforZonetoZone(this.downloadData)
        }
        this.downloadFile(downloadArray);
		},
		async getBaseRateDetail(slabsequence, servicetype) {
			try {
				this.isLoading = true;
				let result;
				let resultArr = [];
				if (this.baseratepresent && this.ischanged == false) {
					let inputPayload = {
						ratetemplateid: this.rateTemplateId,
						slabsequence: slabsequence
					}
					if (!this.isSaved && (!this.callFrom || this.isMasterRate)) {
						let countResult = await MasterService.getBaseRateCount(inputPayload);
						let count = Number(countResult.data.data);
						let limit = 30000;
						let offset = 0;
						let tatlist = [];
						let loop =  Math.ceil(count / limit);
						for (let i = 0; i < loop; i++) {
							inputPayload.limit = limit;
							inputPayload.offset = offset;
							result = await MasterService.getBaserateForDownload(inputPayload);
							resultArr = resultArr.concat(result.data.data)  
							offset = offset + limit;
       				 	}
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id;
						let countResult = await MasterService.getContractBaseRateCount(inputPayload);
						let count = Number(countResult.data.data);
						let limit = 30000;
						let offset = 0;
						let tatlist = [];
						let loop =  Math.ceil(count / limit);
						for (let i = 0; i < loop; i++) {
							inputPayload.limit = limit;
							inputPayload.offset = offset;
							result = await MasterService.getContractBaserateForDownload(inputPayload);
							resultArr = resultArr.concat(result.data.data)  
							offset = offset + limit;
       				 	}

					} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id;
						inputPayload.ratetemplateid = this.callFrom.id;
						let countResult = await MasterService.getClientContractBaserateCount(inputPayload);
						if (countResult.data.code == 103) {
							this.isLoading = false;
							document.activeElement.blur();
							this.$alertify.error(countResult.data.message);
							return true;
						}
						let count = Number(countResult.data.data);
						let limit = 30000;
						let offset = 0;
						let tatlist = [];
						let loop =  Math.ceil(count / limit);
						for (let i = 0; i < loop; i++) {
							inputPayload.limit = limit;
							inputPayload.offset = offset;
							if (servicetype) {
								inputPayload.servicetype = servicetype
							}
							inputPayload.offset = offset;
							result = await MasterService.getClientContractBaserateForDownload(inputPayload);
							resultArr = resultArr.concat(result.data.data)  
							offset = offset + limit;
       				 	}
					}
				}else {
					let inputPayload = {
						tariffcardid: this.tariffCardId,
						slabsequence: slabsequence
					}
					let countResult = await MasterService.getTariffDetailsCount(inputPayload);
						let count = Number(countResult.data.data);
						let limit = 30000;
						let offset = 0;
						let tatlist = [];
						let loop =  Math.ceil(count / limit);
						for (let i = 0; i < loop; i++) {
							inputPayload.limit = limit;
							inputPayload.offset = offset;
							result = await MasterService.getTariffDetailsForDownload(inputPayload);
							resultArr = resultArr.concat(result.data.data)  
							offset = offset + limit;
       				 	}
				}
				this.downloadData = resultArr;
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async downloadFile(downloadData) {
      if(downloadData){
					var blob = new Blob([Papa.unparse(downloadData)], { type: 'text/csv;charset=utf-8;' });
					var link = document.createElement("a");
					var url = URL.createObjectURL(blob);
					link.setAttribute("href", url);
					link.setAttribute("download", 'Rates.csv');
					link.style.visibility = 'hidden';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
        } else {
          this.$alertify.error("Data Not Found");
        }
    },
		async getSlabDetailsUpdate(slabbreakupdetails) {
			try {
				this.isLoading = true;
				this.matrixSlabHeaderArray = [];
				let tempArr = [];
				let tempArrZone = [];
				slabbreakupdetails.sort((a, b) => a.slabnumber - b.slabnumber).forEach((el) => {
					tempArr.push({
						isupload: 0,
						validdata: 0,
						invaliddata: 0,
						tableItems : [],
						downloadLabel : 'Download Rate Template',
						totalPage : 0,
						currentPage :  1,
						totalCount : 0,
						offset :  0,
						pageLimit : 10,
						totalrecords: 0,
						isvalidationdone: false,
						isfilechose: false,
						file: null,
						filename: null
					});
					tempArrZone.push({
						isupload: 0,
						validdata: 0,
						invaliddata: 0,
						tableItems : [],
						downloadLabel : 'Download Rate Template',
						totalPage : 0,
						currentPage :  1,
						totalCount : 0,
						offset :  0,
						pageLimit : 10,
						totalrecords: 0,
						isvalidationdone: false,
						isfilechose: false,
						file: null,
						filename: null
					});

					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue},${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`;
					let lowerlimit = el.lowerlimitvalue;
					let higherlimit = el.higherlimitvalue;
					this.matrixSlabHeaderArray.push({
						id: el.slabnumber,
						name: name,
						lowerlimit: lowerlimit,
						higherlimit: higherlimit
					});
				});
				this.validatedData = tempArr;
				
				if (this.servicetype == 2) {
				 this.validatedDataZonetoZone = tempArrZone;
				}
				this.isLoading = false;
				this.check = true;
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async getTariffCardListing(ratebasis) {
			try {
				this.isLoading = true;
				let inputPayload = {};
				if(ratebasis){
					inputPayload.ratebasis = ratebasis;
				}else{
					inputPayload.ratebasis = this.ratebasis;
				}
				if (this.servicetype) {
                    inputPayload.servicetype = this.servicetype;
                }
				let result = await MasterService.getTariffCardListingForDropDown(inputPayload);

				this.tariffCardList = result.data.data.map((el) => {
					let isdisabled = false;
					if(el.status == 0){
						isdisabled=true
					}
					this.isLoading =false;
					return {
						label: el.tariffcardname,
						id: el.id,
						isDisabled:isdisabled,
						type: el.tariffcardtype
					}
				})
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async getCityNameFromStateIds(baseCityIdsArray) {
			try {
				let payload = {
					cityId: baseCityIdsArray
				}
				this.isLoading = true;
				let result = await MasterService.getCitiesByIds(payload);
				this.isLoading = false;
				let newmatrixHeaderCityArray = this.matrixHeaderCityArray.map((el) => {
					let cityObj = result.data.data.find(o => o.cityid == el.id);
					return {
						id: el.id,
						name: cityObj.cityname
					}
				})
				this.matrixHeaderCityArray = newmatrixHeaderCityArray;
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async saveTariffCard(type, isTabChange) {
			this.type = type;
			if (this.rateTemplateId) {
				this.submitTariffCard(isTabChange);
			} else {
				this.$emit("createAndGetId", {})
			}
		},
		async submitTariffCard(isTabChange) {
			var inputPayload = {};
			if(!this.tariffCardId) {
				if (this.type == "saveAndNext") {
					this.$emit("saveandnext", {isTabChange:isTabChange})
				} else {
					this.$emit("goToNextStepOrListing", 'list')
				}
				return;
			}
			if(this.callFrom && this.callFrom.name==CONSTANT.CLIENT_CONTRACT_TEMPLATE){
				if(this.ischanged==true && this.UpdateRateTatType=='TariffCardTemplate'
					 && this.AnotherTariffCard==null && this.initialTariffcardId!=null){
						 return this.$alert('Please select another template', "", "error");
					return false;
				}else if(this.ischanged==true && this.UpdateRateTatType=='FileUpload' && this.servicetype == 1 ){
					let error = [];
					for (var index = 0; index < this.validatedData.length; index++) {
						if(this.validatedData[index].isvalidationdone == true &&
							this.validatedData[index].invaliddata == 0){
							continue;
						}else{
							if(this.tarifftype == 'slab'){
								error.push(this.getOldSlabDetailsArray[index].slabnumber);
							}
							if(this.tarifftype == 'flat'){
								error.push(0);
							}
						}
					}
					if(error.length > 0 && this.tarifftype == 'slab'){
						this.$alert("Please Upload/Validate Rate for Slab Break "+error.join(", "), "", "error");
						return false;
					}
					if(error.length > 0 && this.tarifftype == 'flat'){
						this.$alert("Please Upload/Validate Rate", "", "error");
						return false;
					}
			}else if(this.ischanged==true && this.addcities == true ){
				let error = [];
				for (var index = 0; index < this.validatedData.length; index++) {
					if(this.validatedData[index].isvalidationdone == true &&
						this.validatedData[index].invaliddata == 0){
						continue;
					}else{
						if(this.tarifftype == 'slab'){
							error.push(this.getOldSlabDetailsArray[index].slabnumber);
						}
						if(this.tarifftype == 'flat'){
							error.push(0);
						}
					}
				}
				if(error.length > 0 && this.tarifftype == 'slab'){
					this.$alert("Please Upload/Validate Rate for Slab Break "+error.join(", "), "", "error");
					return false;
				}
				if(error.length > 0 && this.tarifftype == 'flat'){
					this.$alert("Please Upload/Validate Rate", "", "error");
					return false;
				}
			}else if(this.ischanged==true && this.UpdateRateTatType=='FileUpload' && this.servicetype == 2 && this.addcities == false){
				let error = [];
				for (var index = 0; index < this.validatedDataZonetoZone.length; index++) {
					if(this.validatedDataZonetoZone[index].isvalidationdone == true &&
						this.validatedDataZonetoZone[index].invaliddata == 0){
						continue;
					}else{
						if(this.tarifftype == 'slab'){
							error.push(this.getOldSlabDetailsArray[index].slabnumber);
						}
						if(this.tarifftype == 'flat'){
							error.push(0);
						}
					}
				}
				if(error.length > 0 && this.tarifftype == 'slab'){
					this.$alert("Please Upload/Validate Rate for Slab Break "+error.join(", "), "", "error");
					return false;
				}
				if(error.length > 0 && this.tarifftype == 'flat'){
					this.$alert("Please Upload/Validate Rate", "", "error");
					return false;
				}
			}else if(this.ischanged==true && this.UpdateRateTatType=='FileUpload' && this.servicetype == 2 && this.addcities == true){
				let error = [];
				for (var index = 0; index < this.validatedDataZonetoZone.length; index++) {
					if(this.validatedDataZonetoZone[index].isvalidationdone == true &&
						this.validatedDataZonetoZone[index].invaliddata == 0){
						continue;
					}else{
						if(this.tarifftype == 'slab'){
							error.push(this.getOldSlabDetailsArray[index].slabnumber);
						}
						if(this.tarifftype == 'flat'){
							error.push(0);
						}
					}
				}
				if(error.length > 0 && this.tarifftype == 'slab'){
					this.$alert("Please Upload/Validate Rate for Slab Break "+error.join(", "), "", "error");
					return false;
				}
				if(error.length > 0 && this.tarifftype == 'flat'){
					this.$alert("Please Upload/Validate Rate", "", "error");
					return false;
				}
				for (var index = 0; index < this.validatedData.length; index++) {
					if(this.validatedData[index].isvalidationdone == true &&
						this.validatedData[index].invaliddata == 0){
						continue;
					}else{
						if(this.tarifftype == 'slab'){
							error.push(this.getOldSlabDetailsArray[index].slabnumber);
						}
						if(this.tarifftype == 'flat'){
							error.push(0);
						}
					}
				}
				if(error.length > 0 && this.tarifftype == 'slab'){
					this.$alert("Please Upload/Validate Rate for Slab Break "+error.join(", "), "", "error");
					return false;
				}
				if(error.length > 0 && this.tarifftype == 'flat'){
					this.$alert("Please Upload/Validate Rate", "", "error");
					return false;
				}
			}
		}
			this.isLoading = true;
			inputPayload.lastmodifiedby = this.userName;
			inputPayload.createdby = this.userName;
			inputPayload.tariffcardid = (this.AnotherTariffCard)?this.AnotherTariffCard:this.tariffCardId;
			inputPayload.ratetemplateid = this.rateTemplateId;
			inputPayload.ratebasis = this.selectedEditRowDataEdit.ratebasis;
			inputPayload.slabtype = this.selectedEditRowDataEdit.slabtype;
			inputPayload.baserateslabchargetype = this.baserateslabchargetype || null;
			inputPayload.servicetype = this.servicetype;
			let result;
			if(!this.callFrom){
				result = await MasterService.saveBaseRate(inputPayload);
			} else if(this.callFrom && this.callFrom.name==CONSTANT.CONTRACT_TEMPLATE){
				inputPayload.contractid = this.callFrom.contractid;
				inputPayload.contractservicesid = this.callFrom.contractservicesid;
				inputPayload.ratetemplateid = this.callFrom.id;
				result = await MasterService.saveContractMasterBaseRate(inputPayload);
			} else if(this.callFrom && this.callFrom.name==CONSTANT.CLIENT_CONTRACT_TEMPLATE){
				inputPayload.contractid = this.callFrom.contractid;
				inputPayload.contractservicesid = this.callFrom.contractservicesid;
				inputPayload.ratetemplateid = this.callFrom.id;
				inputPayload.isbaserateslabchargetypechanged = this.isbaserateslabchargetypechanged
				if(this.initialTariffcardId){
					inputPayload.ischanged = this.ischanged;
				}else{
					inputPayload.ischanged = true;
				}
				if(this.UpdateRateTatType=="FileUpload" || this.addcities == true){
					inputPayload.userid = this.userid;
					inputPayload.userreferencestring = this.userreferencestring;
					if (this.addcities) {
						inputPayload.servicetype = 1;
						inputPayload.isExceptionalcities = true;		
						}
					if(this.tarifftype == 'slab'){
						inputPayload.slabdetails = this.getOldSlabDetailsArray;
					}else{
						inputPayload.slabdetails = null;
					}
				}
				result = await MasterService.saveClientContractBaseRate(inputPayload);
			}
			this.isLoading = false;
			if (result.data.code == 200) {
				this.ischanged = false;
				this.ratetemplatelength = 0;
				if (this.servicetype == 1) {
					for (var index = 0; index < this.validatedData.length; index++) {
						this.resetFiles(index);
					}
				}
				if (this.servicetype == 2) {
					for (var index = 0; index < this.validatedDataZonetoZone.length; index++) {
						this.resetFilesZone(index);
					}
					for (var index = 0; index < this.validatedData.length; index++) {
						this.resetFiles(index);
					}
				}
				
				if (this.type == "saveAndNext") {
					this.$emit("saveandnext", {isTabChange:isTabChange})
				} else {
					this.$emit("save", {});
				}
				if (this.callFrom && (this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE || this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE)) {
					this.isSaved= true
				}
			}
		},
		saveOnTabChange(){
			this.submitMatrixData("saveAndNext", true);
		},
		submitMatrixData: function(event, isTabChange) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.saveTariffCard(event, isTabChange);
				}
			}).catch(() => {
				console.log('errors exist', this.errors);
			});
		},
		async createMatrixforZonetoZone(data) {
            // Define the list of zones and initialize an empty matrix
            const matrix = {};
            // Initialize the matrix with zeros
            const matrixArray = this.zones.map((origin) => {
              const row = { '': origin };
              this.zones.forEach((destination) => {
                const foundItem = data.find(item => item.origincity === origin && item.destinationcity === destination);
                row[destination] = foundItem ? foundItem.tariffrate: null;
              });
              return row;
            });
            return matrixArray;
          },
		  async  getZonenamesdata(){
			let inputpayload={}
			this.zones =[];
			let result = await MasterService.GetZoneNames(inputpayload);
			if(result.data.code==200){
			   this.zones = result.data.data
			}else{
			  this.$alertify.success("Zones Data not found");
			}
		  },
		  async validateZoneTariff(index){
			try {
			  this.isLoading = true;
			  var inputPayload = {};
			  // console.log("this.json18x18",this.json18x18);
				inputPayload.arrOfMatrix = this.arrOfMatrix;
				inputPayload.serviceLevelId = this.callFrom.contractservicesid
				inputPayload.userreferencestring = this.userreferencestring
				inputPayload.userid = this.userid
				inputPayload.servicetype = this.servicetype
			 let totalrecords
			 this.validatedDataZonetoZone[index].totalrecords = this.arrOfMatrix.length;
			  let result = await MasterService.validateTariffRate18x18(inputPayload);
			  this.isupload = 1
			  this.isLoading = false;
			  if (result.data.code == 409) {
				this.validatedDataZonetoZone[index].totalCount = result.data.data.invalid18x18Data.length;
				this.validatedDataZonetoZone[index].totalPage = Math.ceil(this.validatedDataZonetoZone[index].totalCount/this.validatedDataZonetoZone[index].pageLimit);
				this.validatedDataZonetoZone[index].tableItems = result.data.data.invalid18x18Data.map((el,index)=>{
				  return {
					'id':index+1,
					'Origin Zone':el.originzone,
					'Destination Zone':el.destinationzone,
					'Rate': el.TAT,
					'Invalid Reason': el.msg,
				  }
				});
				let invalid18x18Data = result.data.data.invalid18x18Data
			this.validatedDataZonetoZone[index].totalrecords = this.arrOfMatrix.length;
			  this.validatedDataZonetoZone[index].invaliddata = parseInt(invalid18x18Data.length);
			  this.validatedDataZonetoZone[index].validdata=(this.validatedDataZonetoZone[index].totalrecords-this.validatedDataZonetoZone[index].invaliddata)
			  this.validatedDataZonetoZone[index].currentPage = 1;
			  this.validatedDataZonetoZone[index].pageLimit = 10;
			  this.validatedDataZonetoZone[index].offset = 0;
			  this.validatedDataZonetoZone[index].totalCount = parseInt(invalid18x18Data.length);
			  this.validatedDataZonetoZone[index].totalPage = Math.ceil(parseInt(invalid18x18Data.length) / this.validatedDataZonetoZone[index].pageLimit);
			  this.validatedDataZonetoZone[index].isvalidationdone = true;

		  this.$alertify.success("File data validated Successfully");
		  } else {
			
			  this.validatedDataZonetoZone[index].isupload = 1;
			  this.validatedDataZonetoZone[index].validdata=this.validatedDataZonetoZone[index].totalrecords;
			  this.validatedDataZonetoZone[index].invaliddata = 0;
			  this.validatedDataZonetoZone[index].isvalidationdone = true;
			  this.$alert(result.data.message, this.seriveLevelTemplateName, "success");
		  }
		  this.validatedDataZonetoZone[index].isDisable = true;
			} catch(err){
			  console.log(err);
			  this.isLoading = false;
			}
		  },
		  async downloadRateTemplateZone(){
			let downloadArray = this.rateTemplateData.map((el)=>{
				return {
						"origincity":el.origincity,
						"destinationcity":el.destinationcity,
						"tariffrate": 0
				}
			});
			let result = await this.createMatrixforZonetoZone(downloadArray)
			this.makeXls(result,'Tariff.csv');
		  },
		  async chooseZoneFile(e, index, isSlab=0) {
			try {
				console.log("xyxxxxx");
				this.ischanged = true;
				this.validatedDataZonetoZone[index].isupload = 0;
				this.validatedDataZonetoZone[index].validdata = 0;
				this.validatedDataZonetoZone[index].invaliddata = 0;
				this.validatedDataZonetoZone[index].tableItems = [];
				this.validatedDataZonetoZone[index].totalPage = 0;
				this.validatedDataZonetoZone[index].currentPage =  1;
				this.validatedDataZonetoZone[index].totalCount = 0;
				this.validatedDataZonetoZone[index].offset =  0;
				this.validatedDataZonetoZone[index].pageLimit = 10;
				const files = e.target.files;
				if (!files.length) {
					this.$refs.zonefile.value = null;
					return;
				} else if (!/\.(csv)$/.test(files[0].name.toLowerCase())) {
					this.$refs.zonefile.value = null;
					return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
				}else{
					this.validatedDataZonetoZone[index].file = e.target.files[0];
					this.validatedDataZonetoZone[index].filename = e.target.files[0].name;
					this.validatedDataZonetoZone[index].isfilechose = true;
					this.validatedDataZonetoZone[index].isvalidationdone = false;
				  	this.validatedDataZonetoZone[index].isDisable = false;
					if(isSlab){
						this.$refs.zonefile[index].value = null;
					}else{
						this.$refs.zonefile.value = null;
					}
                    await this.parse18x18File(index, isSlab);
				}
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		async parse18x18File(index, isSlab){
	
			let tempArr = []
			let tempArrforValidation=[]
			let userid = this.userid;
			let userreferencestring = this.userreferencestring;
			// tempResult.rateperbasis = (result.data['Rate per basis (INR)'])?result.data['Rate per basis (INR)']:null;
			Papa.parse(this.validatedDataZonetoZone[index].file, {
			  header: true, // Assumes the first row contains column headers
			  dynamicTyping: true, // Automatically convert values to their appropriate types
			  before: this.isLoading = true,
			  skipEmptyLines: true,
			  complete: function (result) {
				let data = result.data;
				if (data.length>18) {
					this.isinvalid=true
				   return this.$alert('Invalid 18 x18 template :File headers mismached Origin Zones shold be maximum 18', "", "error");
					  }
				// Iterate through the rows and columns to create the JSON
				for (let i = 0; i < data.length; i++) {
				  let row = data[i];
				  let rowName = row['']; // Row name is in the first column
				  if(Object.keys(row).length>19)
				  {
				   return this.$alert('Invalid 18 x18 template :File headers mismached Destination Zones shold be maximum 18', "", "error");
				  }
				if(Object.keys(row)[0] )
				  {
					this.isLoading = false
					return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
				  }
				if(  !this.zones.includes(rowName))
				  {
					this.isLoading = false
					return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
				  }
				  for (const colName in row) {
					const keysArray = Object.keys(row);
					if( keysArray.indexOf(colName)!=0 && !this.zones.includes(colName))
					  {
					   this.isLoading = false
					   return this.$alert('File headers are not matched. Please download 18 x 18 csv file and use that file to upload data to avoid header mismatch issue.', "", "error");
					  }
					if (colName !== '' && row[colName]!= null) {
					  let zoneName = colName;
					  tempArr.push({origincity : rowName , destinationcity :zoneName , rateperbasis : row[colName] ,servicetype:2,userreferencestring:userreferencestring,userid:userid})
					  tempArrforValidation.push({originzone : rowName , destinationzone :zoneName , TAT : row[colName] ,servicetype:2})
					}
				  }
				}
				if(tempArr.length<1){
					this.isLoading = false;
					this.resetFiles(index);
					return this.$alert('Tariff file data should not be blank. At least one record set is required.', "", "error");
				}
				else{
					this.validatedDataZonetoZone[index].totalrecords = tempArr.length;
				this.chunkArray(tempArr, 20000, index, isSlab);
				}
				this.validatedDataZonetoZone[index].totalrecords = tempArr.length;
				this.validatedDataZonetoZone[index].isupload = 1;
				this.arrOfMatrix = tempArrforValidation
			  }.bind(this)
			});
			this.isLoading = false
		  },
		  resetFilesZone(index) {
			this.validatedDataZonetoZone[index].isvalidation = false;
			this.validatedDataZonetoZone[index].isfilechose = false;
			this.validatedDataZonetoZone[index].validdata = 0;
			this.validatedDataZonetoZone[index].invaliddata = 0;
			this.validatedDataZonetoZone[index].tableItems = [];
			this.validatedDataZonetoZone[index].totalPage = 0;
			this.validatedDataZonetoZone[index].currentPage =  1;
			this.validatedDataZonetoZone[index].totalCount = 0;
			this.validatedDataZonetoZone[index].offset =  0;
			this.validatedDataZonetoZone[index].pageLimit = 10;
			this.validatedDataZonetoZone[index].totalrecords = 0;
			this.validatedDataZonetoZone[index].isvalidationdone = false;
			this.validatedDataZonetoZone[index].file = null;
			this.validatedDataZonetoZone[index].filename = null;
			this.validatedDataZonetoZone[index].isDisable = true;
			this.addcities = false;
		},
		async getexceptionalcitiesservicedetails(){
			if (this.addcities == true) {
				this.isLoading = true;
					//get sales tat from contact services for download Rate Template creation
					let inputPayload = {
					  clientcontractservicesid: this.callFrom.contractservicesid,
					  servicetype : 1
					}
					let result = await MasterService.getClientContractServiceSalesTAT(inputPayload);
					if (result.data.data.length > 0) {
						this.additionalCitiesDownloadTemplate  = result.data.data;
						this.additionalCitiesDownloadTemplateLength = result.data.data.length;
						this.isLoading = false;
						this.ischanged = true
					}else{
						this.addcities = false
						this.isLoading = false;
						return this.$alert('No exeptional cities found in services in this contract', "", "error");
					}

					
			}
		},
		async downloadExceptionalCities(lowerlimit ,higherlimit){
			try {
				this.isLoading = true;
				let downloadData = [];
				this.additionalCitiesDownloadTemplate.forEach(item => {
					let obj = {
						'Origin Region': item.originregion,
						'Origin State': item.originstate,
						'Origin City': item.origincity,
						'Origin Territory': item.originterritory,
						'Destination Region': item.destinationregion,
						'Destination State': item.destinationstate,
						'Destination City': item.destinationcity,
						'Destination Territory': item.destinationterritory,
						'Route Mode': item.travelmode,
						'Rate basis': this.selectedEditRowDataEdit.ratebasis == 1 ? 'Weight' : 'Quantity',
						'Rate Type Flat/Slab': this.selectedEditRowDataEdit.tariffcardtype == 1 ? 'Flat' : 'Slab',
					}
					if (this.selectedEditRowDataEdit.tariffcardtype == 2) {
						obj['Slab Type (Weight/ Quantity)'] = this.selectedEditRowDataEdit.slabtype == 1 ? "Weight" : "Quantity";
						obj["Slab Break (Low - High)"] = parseInt(lowerlimit) + ' to ' + parseInt(higherlimit);
					}
					obj['Rate per basis (INR)'] = "";
					downloadData.push(obj);
				});
				this.makeXls(downloadData,'Tariff.csv');
				this.isLoading = false;
				return true;
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
		async removeExceptionalCities(){
			try {
				this.$confirm("Are you sure you want to remove exceptional lanes?","","question").then(async () => {
					this.isExceptionalcitiespresent = false
					let inputPayload ={ ratetemplateid : this.callFrom.id}
					let result = await MasterService.removeExceptionalCities(inputPayload);
				}).catch((err)=>{
				console.log(err)
				});
			} catch (error) {
				console.log(error);
				this.isLoading = false;
			}
		},
		changebaserateslabchargetype(){
			this.isbaserateslabchargetypechanged = true
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/baserate/baserate.component.js